import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export interface AccountingProviderReference {
  id: string
  name: string
}

export function AccountingMappingSelect({
  id,
  destinations,
  value,
  disabled,
  readOnly = false,
  onChange,
}: {
  id?: string
  destinations: AccountingProviderReference[]
  value?: string
  disabled: boolean
  readOnly?: boolean
  onChange: (value: string | null) => void
}) {
  if (readOnly) {
    return (
      <span className="text-body-sm text-muted-foreground">
        {destinations.find((destination) => destination.id === value)?.name ?? 'Unmapped'}
      </span>
    )
  }

  return (
    <Select
      value={value ?? 'unmapped'}
      disabled={disabled}
      onValueChange={(next) => onChange(next === 'unmapped' ? null : next)}
    >
      <SelectTrigger id={id} className="h-8">
        <SelectValue placeholder="Choose a provider reference" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="unmapped">Unmapped</SelectItem>
        {destinations.map((destination) => (
          <SelectItem key={destination.id} value={destination.id}>
            {destination.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
